<template>
  <div>
    <h3
      v-if="heading"
      class="heading"
    >
      {{ heading }}
    </h3>
    <timezone-field
      ref="tz"
      class="flex-grow-1"
      :name="tz"
      @changed="timezoneChanged"
    />
    <table class="highlight-settings-table">
      <tbody>
        <tr>
          <td class="setting-label">
            <h5>Highlight signals in transcript text</h5>
          </td>
          <td class="setting-control">
            <base-switch
              v-model="highlightSigs"
              type="secondary"
              @input="highlightSigsChanged"
            />
          </td>
        </tr>
        <tr>
          <td class="setting-label">
            <h5>Include search words in transcript text</h5>
          </td>
          <td class="setting-control">
            <base-switch
              v-model="includeSearch"
              type="secondary"
              @input="includeSearchChanged"
            />
          </td>
        </tr>
        <tr>
          <td class="setting-label">
            <h5>Include case keywords in transcript text</h5>
          </td>
          <td class="setting-control">
            <base-switch
              v-model="includeCaseKw"
              type="secondary"
              @input="includeCaseKwChanged"
            />
          </td>
        </tr>
        <tr>
          <td class="setting-label">
            <h5>Include code words in transcript text</h5>
          </td>
          <td class="setting-control">
            <base-switch
              v-model="includeCodeWords"
              type="secondary"
              @input="includeCodeWordsChanged"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="showActions">
      <base-button
        size="sm"
        type="primary"
        @click="$emit('save')"
      >
        Save Preferences
      </base-button>
      <base-button
        size="sm"
        type="secondary"
        @click="reset"
      >
        Cancel
      </base-button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import TimezoneField from "../../Ethos/Util/TimezoneField.vue";
export default {
  name: "user-preferences",
  components: {TimezoneField},
  props: {
    heading: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showActions: false,
      tz: "",
      highlightSigs: false,
      includeSearch: false,
      includeCaseKw: false,
      includeCodeWords: false,
    };
  },
  methods: {
    ...mapGetters("data", [
      "userTimezone",
      "highlightSignalsInText",
      "includeSearchWordSignals",
      "includeCaseKeywordSignals",
      "includeCodeWordSignals",
    ]),
    timezoneChanged(tz) {
      this.tz = tz;
      this.showActions = true;
    },
    highlightSigsChanged(val) {
      this.showActions = true;
    },
    includeSearchChanged(val) {
      this.showActions = true;
    },
    includeCaseKwChanged(val) {
      this.showActions = true;
    },
    includeCodeWordsChanged(val) {
      this.showActions = true;
    },
    reset() {
      this.tz = this.userTimezone();
      this.highlightSigs = this.highlightSignalsInText();
      this.includeSearch = this.includeSearchWordSignals();
      this.includeCaseKw = this.includeCaseKeywordSignals();
      this.includeCodeWords = this.includeCodeWordSignals();
      this.$nextTick(() => {
        this.showActions = false;
      });
    },
  },
  mounted() {
    this.tz = this.userTimezone();
    this.highlightSigs = this.highlightSignalsInText();
    this.includeSearch = this.includeSearchWordSignals();
    this.includeCaseKw = this.includeCaseKeywordSignals();
    this.includeCodeWords = this.includeCodeWordSignals();
    this.$nextTick(() => {
      this.showActions = false;
    });
  },
};
</script>

<style scoped>

.highlight-settings-table {
  border-collapse: separate;
  border-spacing: 10px 0 0 0;
  padding-top: 10px;
}

.highlight-settings-table td {
  padding: 8px 0;
  vertical-align: middle;
}

.setting-label {
  text-align: left;
  width: 70%; /* Adjust as needed */
}

.setting-control {
  text-align: right;
  width: 30%; /* Adjust as needed */
}

.setting-label h5 {
  margin: 0;
  font-weight: 500;
}

</style>
